'use client'

import { doc, getDoc, serverTimestamp, setDoc } from 'firebase/firestore'

import { db } from '@/config/firebase'

export interface CommissionSetting {
  displayName: string
  enabled: boolean
  percentage: number
}

type CommissionSettingsDocument = {
  settings: Record<string, CommissionSetting>
  updatedAt?: unknown
}

const COLLECTION = 'commissionSettings'
const DOCUMENT_ID = 'global'

export class CommissionService {
  static async getSettings(): Promise<Record<string, CommissionSetting> | null> {
    const ref = doc(db, COLLECTION, DOCUMENT_ID)
    const snapshot = await getDoc(ref)

    if (!snapshot.exists()) {
      return null
    }

    const data = snapshot.data() as CommissionSettingsDocument
    return data.settings ?? null
  }

  static async saveSettings(settings: Record<string, CommissionSetting>): Promise<void> {
    const ref = doc(db, COLLECTION, DOCUMENT_ID)
    await setDoc(
      ref,
      {
        settings,
        updatedAt: serverTimestamp(),
      },
      { merge: true }
    )
  }
}
